import { render, staticRenderFns } from "./SlowSickManageCore.vue?vue&type=template&id=c3f2d6c4&"
import script from "./SlowSickManageCore.vue?vue&type=script&lang=js&"
export * from "./SlowSickManageCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports